<template>
  <div>
    <div v-if="(preparedLocations || []).length > 0">
      <MRow :gutter="0" class="px-2" :size="12">
        <MCol :size="3">
          <FlotoFormItem
            :label="`${$tc('geolocation')} ${$tc('last_sync_time')}`"
            disabled
          >
            <span>{{ getLastSyncTimeStamp | datetime }}</span>
          </FlotoFormItem>
        </MCol>
        <MCol>
          <FlotoFormItem
            :label="$tc('geolocation_last_sync_location')"
            disabled
          >
            <span v-if="geolocationLastSyncLocation">
              {{ geolocationLastSyncLocation.address }}
              <span
                v-if="
                  geolocationLastSyncLocation.latLng.lat &&
                  geolocationLastSyncLocation.latLng.lng
                "
              >
                ({{ geolocationLastSyncLocation.latLng.lat }},
                {{ geolocationLastSyncLocation.latLng.lng }})
              </span>
            </span>
            <span v-else>---</span>
          </FlotoFormItem>
        </MCol>
      </MRow>
      <LeafletGeoMap
        :all-locations="preparedLocations"
        style="width: 100%; height: 550px"
      />
    </div>

    <span v-else>
      <FlotoNoData />
    </span>
  </div>
</template>
<script>
import { getGeolocationCoordinatesApi } from '@src/modules/asset/asset-api.js'
import LeafletGeoMap from '@src/components/map/leaflet-geo-map.vue'
export default {
  name: 'LocateOnMap',
  components: { LeafletGeoMap },
  props: {
    disabled: { type: Boolean, default: false },
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
    defaultLocationName: { type: String, default: '' },
  },
  data() {
    return {
      preparedLocations: [],
      address: '',
      unknownLocationAddress: null,
    }
  },
  computed: {
    getLastSyncTimeStamp() {
      const data = this.preparedLocations[0]
      if (data.lastSyncTime) {
        return data.lastSyncTime
      } else return '---'
    },
    geolocationLastSyncLocation() {
      const data = this.preparedLocations[0]
      if (data.locationName) {
        return { address: data.locationName, latLng: data.latLng }
      } else if (
        this.resource.defaultLocationName &&
        this.resource.defaultLatitude &&
        this.resource.defaultLongitude
      ) {
        return {
          address: this.resource.defaultLocationName,
          latLng: {
            lat: this.resource.defaultLatitude,
            lng: this.resource.defaultLongitude,
          },
        }
      } else return '---'
    },
  },
  created() {
    setTimeout(() => {
      this.getGeolocationCoordinates()
    }, 100)
  },
  methods: {
    async getGeolocationCoordinates() {
      let filters = {}
      if (this.resource.id) {
        filters.ids = this.resource.id
      }
      return getGeolocationCoordinatesApi(filters).then((data) => {
        const preparedLocations = []
        data.items.forEach((i) => {
          let locationName = i.locationName
          const apiFn =
            locationName === 'unknown'
              ? this.getAddressFromOpenStreetMap
              : this.getAddressFromInHouseApi
          apiFn(i).then((ad) => {
            preparedLocations.push({
              id: this.resource.id,
              latLng: {
                lat: i.latitude,
                lng: i.longitude,
              },
              locationName: ad.locationName,
              assetId: i.name,
              assetType: i.assetTypeId,
              assetName: i.displayName,
              lastSyncTime: i.lastSyncTime,
            })
          })
        })
        this.preparedLocations = preparedLocations
      })
    },
    getAddressFromInHouseApi(i) {
      return new Promise((resolve) => {
        return resolve({
          locationName: i.locationName,
        })
      })
    },
    getAddressFromOpenStreetMap(i) {
      return fetch(
        `https://nominatim.openstreetmap.org/search.php?q=${i.latitude},${i.longitude}&polygon_geojson=1&format=json`
      )
        .then((response) => response.json())
        .then((j) => {
          return {
            locationName: j[0].display_name,
          }
        })
    },
  },
}
</script>
